import React from 'react'
import PropTypes from 'prop-types'
import { Redirect } from 'react-router'
import useAuth from '../../../hooks/useAuth'
import AppRoutes from '../../../routes/appRoutes'
import InputText from '../../../components/InputText/InputText'
import { initialValues, validationSchema } from '../../../forms/LoginForm'
import { useFormik } from 'formik'
import Button from '../../../components/Button/Button'
import clsx from 'clsx'
import InputPassword from '../../../components/InputText/components/InputPassword'
import DisabledLink from './DisabledLink'

const LoginForm = props => {
    const { redirect, loginUnavailable } = props
    const { handleAuthorize, authenticated, role, errors } = useAuth()

    const {
        handleSubmit,
        isValid,
        isSubmitting,
        setSubmitting,
        getFieldProps,
        errors: loginErrors,
        touched,
        values,
    } = useFormik({
        initialValues,
        validationSchema,
        onSubmit: formValues => {
            setSubmitting(true)
            processSubmit(formValues)
            setSubmitting(false)
        },
    })

    const processSubmit = request => {
        return handleAuthorize(request)
    }

    if (authenticated) {
        if (window.Intercom != null) {
            window.Intercom('shutdown')
        }
        if (role === 'admin' || role === 'salesperson') {
            return <Redirect to={AppRoutes.adminHome()} />
        } else {
            return <Redirect to={redirect} />
        }
    }

    const loginLinkPageUrl =
        values?.email !== ''
            ? AppRoutes.loginLink(`email=${encodeURIComponent(values?.email)}`)
            : AppRoutes.loginLink()

    return (
        <form
            onSubmit={handleSubmit}
            className="flex flex-col items-center justify-start gap-y-1 w-full"
        >
            <InputText
                {...getFieldProps('email')}
                error={touched['email'] && loginErrors['email']}
                placeholder="Enter email"
                label="Email"
                variant="black"
                disabled={loginUnavailable}
            />
            <InputPassword
                {...getFieldProps('password')}
                error={touched['email'] && loginErrors['password']}
                label="Password"
                variant="black"
                disabled={loginUnavailable}
                helperText={
                    <DisabledLink
                        to={AppRoutes.forgotPassword()}
                        disabled={loginUnavailable}
                        className="text-sm font-medium text-black30 underline min-w-max"
                    >
                        Forgot Password?
                    </DisabledLink>
                }
            />
            <div className="w-full h-auto flex items-center justify-center flex-col mt-1 gap-y-4">
                <div className="flex w-full flex-col items-center justify-center gap-y-2">
                    <Button
                        text="Sign In"
                        type="submit"
                        variant="secondary"
                        disabled={
                            loginUnavailable || (!isSubmitting && !isValid)
                        }
                        className="w-full disabled:bg-yellow disabled:text-black disabled:border-yellow"
                    />
                    <span className="font-medium text-sm text-white">
                        or{' '}
                        <DisabledLink
                            to={loginLinkPageUrl}
                            disabled={loginUnavailable}
                            className="text-black30 underline"
                        >
                            email me a login link
                        </DisabledLink>
                    </span>
                </div>
                <p
                    className={clsx(
                        errors[0] ? 'visible' : 'invisible',
                        'transition-all delay-200  text-error font-medium text-sm',
                    )}
                >
                    {errors[0]}
                </p>
            </div>
        </form>
    )
}

LoginForm.propTypes = {
    redirect: PropTypes.string.isRequired,
    loginUnavailable: PropTypes.bool.isRequired,
}

export default LoginForm
